export enum AppModules {
  LoanRepayment,
  SanjeevaniYojana,
  SuvidhaYojna,
}
